@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../constants/spacing.module.less';

@solidGreyBorder: 1px solid @settings-page--printing-connect-workstation--border-color;

.install-button {
  height: 80px;
  display: flex;
  place-content: center center;
  align-items: center;
}

.note {
  padding-top: 20px;
  margin-bottom: @space-16;
  font-style: italic;
  font-size: 14px;
}

.list {
  display: block;
  padding-bottom: 10px;
}

.row {
  display: grid;
  grid-template-columns: auto 17% 17%;

  &:nth-child(even) {
    background: @settings-page--printing-connect-row-even--background-color;
  }

  &:hover {
    .edit {
      visibility: visible;
    }
  }
}

.name {
  padding: 8px 0;

  &:first-child {
    padding-left: 8px;
  }
}

.device-type {
  width: 100%;
  font-size: 18px;
  font-weight: 600;
  padding: 5px;
  display: flex;
  justify-content: space-between;
}

.no-devices {
  padding: 5px 30px 10px;
}

.item-icon {
  height: 12px;
  padding-right: 5px;
}

.edit {
  visibility: hidden;
  padding: 0 5px;
  font-size: 12px;
  cursor: pointer;

  > svg {
    padding-left: 5px;
    height: 12px;
  }
}

.workstation-header {
  border-bottom: @solidGreyBorder;
  padding: 20px 0 5px 10px;
  margin-bottom: 10px;
  display: grid;
  grid-template-columns: auto 17% 17%;

  .workstation-icon {
    height: 20px;
    fill: @settings-page--printing-connect-name--icon-color;
    padding: 2px 5px 0 0;
  }

  .workstation-name {
    font-size: 20px;
    font-weight: 700;
    color: @settings-page--printing-connect-name--text-color;

    &:hover {
      .edit-workstation {
        visibility: visible;
      }
    }
  }

  .edit-workstation {
    &:extend(.edit);
    height: 15px;
    padding: 0 15px;

    > svg {
      fill: @settings-page--printing-connect-workstation--icon-color;
      height: 15px;
      padding: 0 5px;
    }
  }

  &.offline {
    .workstation-name {
      color: @settings-page--printing-connect-workstation--disabled--text-color;
    }

    .workstation-icon {
      fill: @settings-page--printing-connect-workstation--disabled--icon-color;
    }

    .checkbox-column-items {
      visibility: hidden;
    }
  }

  &.no-bottom-border {
    border-bottom: none;
  }
}

.main {
  width: 400px;
  padding: 20px;
}

.field-wrapper {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 5px 0;

  .field {
    width: 40%;
    padding: 0 10px;
  }
}

.fields {
  margin: 10px 0;
  padding: 2px 0;
  border-top: 2px solid @settings-page--printing-connect-edit-modal--border-color;
  border-bottom: 2px solid @settings-page--printing-connect-edit-modal--border-color;
}

.checkbox-column-items {
  display: flex;
  place-self: center center;
  cursor: help;

  .checkbox-info {
    fill: @settings-page--printing-connect-checkbox--icon-color;
    border-radius: 10px;
    height: 18px;
    padding: 2px 6px;
  }
}

.workstation-info {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  align-items: center;
  font-size: 14px;
  line-height: 16px;
  border-top: @solidGreyBorder;
  padding: 5px;

  .deactivate {
    padding-left: 5px;
  }
}

.action-button {
  width: 100%;
  margin: 5px 0;
}

.dims-message {
  margin-top: 10px;
}

.subtitle {
  padding: @space-16 @space-0;
}
